<template>
    <div id="voucherPaymentMaintenanceDetail">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Voucher Payment Maintenance Detail</div>
                    <div class="btn-groups text-right">
                        <button v-if="detailStatus == 'pending'" type="button" id="vchPrintBtn" class="btn btn-secondary" v-on:click.prevent="printPayment">
                            <i class="fp-print"> </i> Print
                        </button>
                        <button v-if="detailStatus == 'in progress'" type="button" id="vchConfirmBtn" class="btn btn-secondary" v-on:click.prevent="performAction('confirm')">
                            <i class="fp-save"> </i> Confirm
                        </button>
                        <button v-if="detailStatus == 'in progress'" type="button" id="vchResetBtn" class="btn btn-secondary" v-on:click.prevent="performAction('reset')">
                            <i class="fp-refresh"> </i> Reset
                        </button>
                        <button v-if="detailStatus != '' && detailStatus != 'pending'" type="button" id="vchExportBtn" class="btn btn-secondary" v-on:click.prevent="performAction('export')">
                            <i class="fp-export"> </i> Export Payment
                        </button>
                        <button v-if="detailStatus != '' && detailStatus != 'pending'" type="button" id="vchDownloadBtn" class="btn btn-secondary" v-on:click.prevent="performAction('download')">
                            <i class="fp-download"> </i> Download
                        </button>
                        <router-link class="btn btn-primary" v-bind:to="{name: 'VoucherPaymentMaintenanceList'}" > <i class="fp-back"> </i> Back</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <data-table-filter-config :moduleName="'voucherPaymentMaintenanceDetail'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess1" class="alert-success p-2" id="paymentBatchMsg">Current batch {{batchNum1}} is processing. Please wait while we generate payment register !!</p>
                        <p v-if="batchError1" class="alert-danger p-2" id="pmtErrorBatchMsg">{{batchErrorMsg1}}<button type="button" class="close close-alert" v-on:click="batchError1 = false;batchErrorMsg1 = ''">×</button></p>
                        <section class="data-table bg-white">
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange" :moduleName="'voucherPaymentMaintenanceDetail'" :position="'top'">
                            </custom-pagination>
                            <vue-good-table
                                    ref="listVoucherPymtMaintDetail"
                                    mode="remote"
                                    @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    :totalRows="totalRecords"
                                    @on-select-all="onSelectAll"
                                    title="Voucher Payment Maintenance Detail"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :paginate="true"
                                    :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }"
                                >
                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>
                                <div slot="selected-row-actions">
                                    <button v-if="canDelete && detailStatus == 'pending'" id="VoucherPmtMaintDetailBtn" v-on:click.prevent="deleteRecord" class="btn btn-danger">Delete</button>
                                </div>
                            </vue-good-table>
                            <custom-pagination
                                :page-changed="onPageChange"
                                :per-page-changed="onPerPageChange">
                            </custom-pagination>
                        </section>    
                    </div>
                </div>        
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>
</template>
<script>
import Vue from 'vue';
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);
let msgServer;
import EventBus from ".././event-bus";
export default {
    name: "VoucherPaymentMaintenanceDetail",
    metaInfo: {
        title: "Voucher Payment Maintenance Detail | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({ 
        firstLoad:0,
        userColumns:[],
        columns:[
            {
                label: 'Voucher Number',
                field: 'voucher',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Invoice Number',
                field: 'invoice_number',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Invoice Date',
                field: 'invoice_date',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Amount',
                field: 'amount',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Status',
                field: 'voucher_status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems: ['Entered','Verified','Approved','Disapproved','Paid','Void','Confirmed','In Progress','Closed'], // dropdown (with selected values) instead of text input
                }
            },
            {
                label: 'Is Error',
                field: 'is_error',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Is Error", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems: ["Yes","No"], // dropdown (with selected values) instead of text input
                }
            },
            {
                label: 'Reason',
                field: 'reason',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
            {
                label: 'Batch',
                field: 'vpm_batch',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
            },
        ],
        rows: [],
        totalRecords: 0,
        loading:false,
        permissions:[],
        cantAccessPage:'',
        action:'list',
        canDelete:false,
        detailStatus:'',
        batchId1:'',
        batchProcess1:false,
        batchNum1:'',
        batchError1:false,
        batchErrorMsg1:''
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_voucher_payment_maintenance_detail') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'delete_voucher_payment_maintenance_detail') {
                    self.canDelete = true;
                }
            });
            if (self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        }
    },
    created: function() {
        this.serverParams.sort = {field:"id",type:"asc"};
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
    },
    methods: {
        cancelAll: function (cancelAll) {
            this.$refs.listVoucherPymtMaintDetail.unselectAllInternal();
        },
        loadList: function(){
            var self = this;
            var data = this.$refs['listVoucherPymtMaintDetail'].selectedRows;
            var use = [];
            for (var i = 0; i < data.length; i++) {
                use.push(this.$refs['listVoucherPymtMaintDetail'].selectedRows[i].id)
            }
            self.loading =  true;
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/voucher-payment-maintenance/detail",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: this.serverParams.columnFilters,
                    sort:self.serverParams.sort,
                    action:self.action,
                    batch:self.$route.params.id,
                    selectedRows:use,
                    all:self.serverParams.selectedAll,
                },
                success: function (data) {
                    self.loading =  false;

                    if (data.status == "success") {
                        if (self.action == "delete") {
                            self.action = "list";
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            if (self.rows.length > 0) {
                                if (self.rows[0].vpm_status != undefined && self.rows[0].vpm_status != null && self.rows[0].vpm_status != "") {
                                    self.detailStatus = self.rows[0].vpm_status;
                                }else{
                                    self.detailStatus = "";
                                }
                            }else{
                                self.detailStatus = "";
                            }
                        } 
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'voucher-payment-maintenance-list')
                }
            });
        },
        deleteRecord() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Voucher Payment Maintenance Detail?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.action = "delete";
                    self.loadList();
                } else {
                }
            });
        },
        paymentBatchStatus:function(){
            var self = this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId1, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.batchProcess1 = false;
                        self.loadList();
                        sse.close();
                    }else if (data.status == "2") {
                        self.batchProcess1 = false;
                        self.batchError1 = true;
                        self.batchErrorMsg1 = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });
        },
        printPayment() {
            var self = this;
            self.loading =  true;
            $.ajax({
                url: process.env.ROOT_API + "/voucher-payment-maintenance/print",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    id:self.$route.params.id,
                },
                success: function (data) {
                    self.loading =  false;

                    if (data.status == "success") {
                        if (data.content.batch_id){
                            self.batchProcess1 = true;
                            self.batchId1 = data.content.batch_id;
                            self.batchNum1 = data.content.batch;
                            self.paymentBatchStatus();
                        }
                    }else{
                        self.$swal('',data.message,'info');
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'print-voucher-payment-maintenance')
                }
            });
        },
        performAction(flag) {
            var self = this;
            if (flag == 'confirm' || flag == 'reset') {
                self.$swal({
                    title: 'Are you sure that you want to '+ flag + '?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.performOperation(flag);
                    } else {

                    }
                });
            }else{
                self.performOperation(flag);
            }
        },
        performOperation(flag) {
            var self = this;
            self.loading =  true;
            $.ajax({
                url: process.env.ROOT_API + "/voucher-payment-maintenance/action",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    id:self.$route.params.id,
                    flag:flag
                },
                success: function (data) {
                    self.loading =  false;

                    if (data.status == "success") {
                        if (flag == "confirm" || flag == "reset") {
                            self.$swal('',data.message,'success');
                        }else{
                            if (flag == "download" || flag == "export") {
                                if (data.content != null && data.content != "") {
                                    var link = document.createElement('a');
                                    document.body.appendChild(link);
                                    link.href = data.content;
                                    link.download = '';
                                    link.target = "_blank";
                                    link.click();
                                }                                
                            }
                        }
                        self.loadList();
                    }else{
                        self.$swal('',data.message,'info');
                    }

                },
                error: function (jqXHR, exception) {
                    self.loading =  false;
                    self.generateStatusCodeMessage(jqXHR, false, 'voucher-payment-maintenance-action')
                }
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/accounting/VoucherPaymentMaintenanceDetail.vue